import React from 'react';

const TargetIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
    {/* <path d="M5.18.07a.27.27,0,0,0-.36,0,.29.29,0,0,0-.07.18v3a.25.25,0,0,0,.43.18.29.29,0,0,0,.07-.18v-3A.29.29,0,0,0,5.18.07Z" />
    <path d="M5,4.5a.54.54,0,0,0-.28.08.58.58,0,0,0-.18.23.48.48,0,0,0,0,.29.53.53,0,0,0,.39.39.48.48,0,0,0,.29,0,.58.58,0,0,0,.23-.18A.54.54,0,0,0,5.5,5,.51.51,0,0,0,5,4.5Z" />
    <path d="M5.18,6.57a.25.25,0,0,0-.43.18v3a.25.25,0,0,0,.43.18.29.29,0,0,0,.07-.18v-3A.29.29,0,0,0,5.18,6.57Z" />
    <path d="M9.93,5.18a.25.25,0,0,0-.18-.43h-3a.25.25,0,0,0-.18.43.29.29,0,0,0,.18.07h3A.29.29,0,0,0,9.93,5.18Z" />
    <path d="M3.43,5.18a.25.25,0,0,0-.18-.43h-3a.29.29,0,0,0-.18.07.27.27,0,0,0,0,.36.29.29,0,0,0,.18.07h3A.29.29,0,0,0,3.43,5.18Z" /> */}
    <path d="M5,4.25a.75.75,0,0,0-.69.46.83.83,0,0,0,0,.44.78.78,0,0,0,.59.59.83.83,0,0,0,.44,0A.75.75,0,0,0,5.75,5,.75.75,0,0,0,5,4.25Z" />
    <path d="M5,0a.5.5,0,0,0-.5.5V3a.5.5,0,0,0,1,0V.5A.5.5,0,0,0,5,0Z" />
    <path d="M5,6.5a.5.5,0,0,0-.5.5V9.5a.5.5,0,0,0,1,0V7A.5.5,0,0,0,5,6.5Z" />
    <path d="M10,5a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H9.5A.5.5,0,0,0,10,5Z" />
    <path d="M3.5,5A.5.5,0,0,0,3,4.5H.5a.5.5,0,0,0,0,1H3A.5.5,0,0,0,3.5,5Z" />
  </svg>
);

export default TargetIcon;
